import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <h4>{{ 'licence.Collected points' | translate }}</h4>
        <table class="data01 mt1em">
            <thead>
            <tr>
                <th>{{ 'licence.Title' | translate }}</th>
                <th>{{ 'licence.Points' | translate }}</th>
                <th>{{ 'licence.Points obtainment date' | translate }}</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
                <tr ng-repeat="item in vm.period.licencePoints">
                    <td ng-if="item.courseId">
                        <a ui-sref="authorized.courses.courses.edit.general({ id:  item.courseId})"> {{ item.title }}</a>
                    </td>
                    <td ng-if="!item.courseId">{{ item.title }}</td>
                    <td>{{ item.points }}</td>
                    <td>{{ item.obtainmentDate ? vm.MomentService.formatDate(item.obtainmentDate) : '' }}</td>
                    <td class="actions">
                        <a class="btn edit"
                            ng-if="vm.isPointEditable(item)"
                            ng-click="vm.parentScope.vm.manage({ licencePoint: item })"
                        >{{ 'licence.Edit' | translate }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
    `
})
export default class {
    constructor ($scope, lodash, MomentService) {
        this.lodash = lodash;
        this.parentScope = $scope.$parent;
        this.MomentService = MomentService;
    }

    $onInit () {
        const { parentScope } = this;
        this.period = parentScope.vm.periods[parentScope.index];
    }

    isPointEditable (licencePoint) {
        return this.period.isActivePeriod && licencePoint.occurrenceId === null;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/detail/licences/points/index.js